import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  MOMO_MANAGE_VACATIONS_REPOSITORY,
  MomoManageVacationsRepository
} from '@app/domain/repositories/manage-vacations/momo/momo-manage-vacations.repository.contract';
import { MomoManageVacationsUseCases } from '@app/domain/use-cases/manage-vacations/momo/momo-manage-vacations.use-cases.contract';
import { SEASONS } from '@app/entities/enums/manage-vacations/manage-vacations.enum';
import { ManageVacationsCriteria } from '@app/entities/models/manage-vacations/manage-vacations-criteria.model';
import { EmployeeObservations, SeasonCalendar } from '@app/entities/models/manage-vacations/manage-vacations.model';
import { MomoManageVacationsProposals } from '@app/entities/models/manage-vacations/momo-manage-vacations.model';
import { TUserTypeCalendarProposal } from '@app/entities/types/manage-vacations.type';

@Injectable({
  providedIn: 'root'
})
export class MomoManageVacationsUseCasesImpl implements MomoManageVacationsUseCases {
  #momoManageVacationsRepository: MomoManageVacationsRepository = inject(MOMO_MANAGE_VACATIONS_REPOSITORY);

  getProposals(): Observable<MomoManageVacationsProposals> {
    return this.#momoManageVacationsRepository.getProposals();
  }

  getVacationsCriteria(): Observable<ManageVacationsCriteria> {
    return this.#momoManageVacationsRepository.getVacationsCriteria();
  }

  getSeasonCalendar(season: SEASONS): Observable<SeasonCalendar<TUserTypeCalendarProposal>> {
    return this.#momoManageVacationsRepository.getSeasonCalendar(season);
  }
  createProposal(proposals: MomoManageVacationsProposals): Observable<MomoManageVacationsProposals> {
    return this.#momoManageVacationsRepository.createProposal(proposals);
  }

  updateObservations(observations: string): Observable<EmployeeObservations> {
    return this.#momoManageVacationsRepository.updateObservations(observations);
  }
}
